/**
 * Begin the GitLab OAuth Authorization Code + PKCE flow (Story 013.2 AC2).
 *
 * Mirrors connect-with-gitlab's own demo `beginLogin` wiring: builds the
 * authorize URL via the library, stores `state` + `codeVerifier` in
 * sessionStorage under fixed keys, then redirects.
 */
import { buildAuthorizationUrl } from '@gl-demo-ultimate-odupre/connect-with-gitlab';
import type { ResolvedOAuth2Auth } from '@gl-demo-ultimate-odupre/connect-with-gitlab';

export const OAUTH_STATE_SESSION_KEY = 'cwc-oauth-state';
export const OAUTH_CODE_VERIFIER_SESSION_KEY = 'cwc-oauth-code-verifier';

export interface OAuthLoginConfig {
  baseUrl: string;
  auth: ResolvedOAuth2Auth;
}

export interface BeginLoginDeps {
  sessionStorage: Storage;
  redirect: (url: string) => void;
}

export async function beginLogin(config: OAuthLoginConfig, deps: BeginLoginDeps): Promise<void> {
  const { url, state, codeVerifier } = await buildAuthorizationUrl(config);
  deps.sessionStorage.setItem(OAUTH_STATE_SESSION_KEY, state);
  deps.sessionStorage.setItem(OAUTH_CODE_VERIFIER_SESSION_KEY, codeVerifier);
  deps.redirect(url);
}
